/**
 * Where links met inside Pages go in this tab: a console link (Decision 23)
 * opens its own route here, whatever origin it was written with; a page's tab
 * uri (as the marks list and the editor name pages) opens that page's route.
 * Anything else is not the console's to open.
 */
import { CONSOLE_LINK_ORIGIN, isCollabUri, parseCollabUri } from '@nimbalyst/collab-protocol';
import { orgDocumentPath, orgPageItemPath, type RouteTeam } from '../routing';

/** The in-app path a console link opens, or null for any other URL. */
export function consolePathForHref(href: string, origin: string): string | null {
  let url: URL;
  try {
    url = new URL(href, origin);
  } catch {
    return null;
  }
  if (url.origin !== CONSOLE_LINK_ORIGIN && url.origin !== origin) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

/** The route of a page by its tab uri; null for a Personal page, which lives on its author's desktop. */
export function pageUriPath(uri: string, team: RouteTeam, projectId: string): string | null {
  if (uri.startsWith('tracker://')) {
    const itemId = decodeURIComponent(uri.slice('tracker://'.length));
    return itemId ? orgPageItemPath(team, projectId, itemId) : null;
  }
  if (isCollabUri(uri)) {
    try {
      return orgDocumentPath(team, projectId, parseCollabUri(uri).documentId);
    } catch {
      return null;
    }
  }
  return null;
}
